import Vue from 'vue';
import App from './App.vue';
import "./assets/css/style.css";


// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);


// Iview
import 'view-design/dist/styles/iview.css'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/pt-BR'
Vue.use(ViewUI, { locale })

// Vue The Mask
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import axios from './api/axios';
Object.defineProperty(Vue.prototype, '$axios', {value: axios});


// Theme Configurations
import '../themeConfig.js';

// Globally Registered Components
// import './globalComponents.js';


// Styles: SCSS
import './assets/scss/main.scss';


// Tailwind
import '@/assets/css/main.css';


import router from './router';


import store from './store/store';


// VeeValidate
import pt_BR from 'vee-validate/dist/locale/pt_BR';
import VeeValidate, { Validator } from 'vee-validate';
Vue.use(VeeValidate, {
  fieldsBagName: 'fieldsname',
});
Validator.localize('pt_BR', pt_BR);


// PrismJS
import 'prismjs';
import 'prismjs/themes/prism.css';

// Feather font icon
require('./assets/css/iconfont.css');


import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);


import VueGoogleCharts from 'vue-google-charts';
Vue.use(VueGoogleCharts);


Vue.config.productionTip = process.env.NODE_ENV === "development";


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
